import { useMemo } from 'react';

import { UseFilterValuesType } from '@/components/FilterNew/types';
import useProjectStages from '@/modules/tasks/views/TasksDashboard/hooks/useProjectStages';

import { getProjectStageFilterOption } from '../utils';

const EMPTY_ARRAY: never[] = [];

const useProjectStagesFilterValues: UseFilterValuesType = ({ value, queryParams }) => {
  const { stages, fetching, error } = useProjectStages({
    projectId: queryParams.projectId,
  });

  const selectedOptions = useMemo(() => {
    if (!value.length) {
      return EMPTY_ARRAY;
    }

    const selectedStages = stages?.filter(({ stageId }) => value.includes(stageId)) || [];
    const selectedOptions = selectedStages?.map(getProjectStageFilterOption);
    return selectedOptions;
  }, [stages, value]);

  return { fetching, resolvedValue: selectedOptions?.map(({ label }) => label), selectedOptions };
};

export default useProjectStagesFilterValues;
